/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EOrigineDossier {
    Hope = 'Hope',
    Walter = 'Walter'
}


export function EOrigineDossierFromJSON(json: any): EOrigineDossier {
    return EOrigineDossierFromJSONTyped(json, false);
}

export function EOrigineDossierFromJSONTyped(json: any, ignoreDiscriminator: boolean): EOrigineDossier {
    return json as EOrigineDossier;
}

export function EOrigineDossierToJSON(value?: EOrigineDossier | null): any {
    return value as any;
}

